import PageRequest from '../../../../../../pagination-helper/lib/PageRequest';

/**
 * * Модель запроса на получение подзадач для добавления
 */
export default class GetSubtaskShortListRequest  {
	/**
	 * * Пагинация
	 */
	Page!: PageRequest;
	/**
	 * * Строка поиска
	 */
	Search!: string;
	/**
	 * * Не включать дочерние задачи с родителем
	 */
	WithoutChildTask: boolean = false;
	/**
	 * * Не включать родительские задачи
	 */
	WithoutParentTask: boolean = false;
	/**
	 * * Список игнорируемых задач для поиска
	 */
	IgnoreTaskList!: Array<number>;
	/**
	 * * Главная задача отноительно которой применяется поиск
	 */
	MainTaskId!: number;
	constructor(obj?: Partial<GetSubtaskShortListRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
